import React from 'react';
import './Member.css';
import Header from '../components/header';
import tokuraphoto from '../images/tokura.jpg'; // 画像ファイルのパスを適切に変更してください

const members = [
  {
    name: '戸倉征史朗（運営）',
    description: '2023年に和歌山大学経済学部を卒業．和歌山大学マンドリンクラブにて指揮を担当．ギターパート．',
    photo: tokuraphoto,
  },
  {
    name: '戸倉征史朗（運営）',
    description: '2023年に和歌山大学経済学部を卒業．和歌山大学マンドリンクラブにて指揮を担当．ギターパート．',
    photo: tokuraphoto,
  },
  // 他のメンバー情報を追加できます
];

const Member = () => {
  return (
    <div className="member-list">
        <Header />
        <div className="form-container">
            {members.map((member, index) => (
            <div key={index} className="member-container">
                <div className="member-photo">
                <img src={member.photo} alt={member.name} />
                </div>
                <div className="member-info">
                <h2>{member.name}</h2>
                <p>{member.description}</p>
                </div>
            </div>
            ))}
        </div>
    </div>
  );
};

export default Member;